module.exports = __webpack_public_path__ + "assets/assets/images/icons/tick.6dc7affe.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/icons/tick.svg
// module id = 214
// module chunks = 0